import React from 'react';
import { IAuditoriaIntegridadeLancamentosResultado } from '../interfaces/IAuditoriaIntegridadeLancamentos';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaIntegridadeLancamentosResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Integridade e Rastreabilidade de Lançamentos — não é um tributo, é uma
// auditoria documental complementar (ITG 2000 / Art. 290 RIR/2018): lançamentos manuais com
// histórico genérico e sem identificação de CPF/CNPJ, nome ou palavra estrutural conhecida.
const AuditoriaResumoIntegridadeLancamentos: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.lancamentosGenericos?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Integridade e Rastreabilidade de Lançamentos</h3>
      <p className='text-muted'>
        Auditoria documental complementar — lançamentos manuais com histórico genérico e sem identificação de
        CPF/CNPJ, nome ou palavra estrutural conhecida configuram fragilidade documental (ITG 2000 / Art. 290 RIR/2018).
        Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Volume sob Risco Documental</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_INTEGRIDADE_LANCAMENTOS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Integridade de Lançamentos</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} lançamento{totalOcorrencias === 1 ? '' : 's'} genérico{totalOcorrencias === 1 ? '' : 's'} identificado{totalOcorrencias === 1 ? '' : 's'} de {resultado.totalLancamentosAnalisados} analisado{resultado.totalLancamentosAnalisados === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Multa de 5% contingente, limitada a 1% da RB (Art. 12, II, Lei 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoIntegridadeLancamentos;
